<template>
    <div v-if="subcontrata" class="z-70 fixed fixed top-0 left-0 w-full h-full flex items-center justify-center">
        <div @click="subcontrata = null" class="absolute top-0 left-0 w-full h-full bg-blue-400 z-70 opacity-50"></div>
        <div class="bg-white relative z-70 shadow-lg rounded-lg w-full max-w-6xl">
            <div class="p-8">
                <div>
                    <div class="mb-3">
                        <label>
                            <span>Tipo</span>
                            <select class="border rounded-lg border-gray-300 w-full p-2 mt-2" v-model="subcontrata.tipo">
                                <option value="">Selecciona Tipo...</option>
                                <option value="AUTONOMO">AUTONOMO</option>
                                <option value="EMPRESA">EMPRESA</option>
                            </select>
                        </label>
                    </div>
                    <div v-if="subcontrata.tipo == ''">
                        <p class="m-1 py-1 px-4 bg-orange-400 text-white rounded-xl inline-block"><AlertTriangleIcon class="mr-2 w-4 inline-block"/> Por favor, seleccione un tipo para continuar.</p>
                    </div>
                    <div v-if="subcontrata.tipo == 'AUTONOMO'">
                        <div class="mb-3">
                            <label>
                                <span>Nombre y apellidos</span>
                                <input v-model="subcontrata.nombre_y_apellidos" type="text" class="input w-full border mt-2" placeholder="Nombre y apellidos" />
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>
                                <span>DNI</span>
                                <input v-model="subcontrata.dni" type="text" class="input w-full border mt-2" placeholder="DNI" />
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>
                                <span>Relacion de actividades a desempeñar</span>
                                <input v-model="subcontrata.relacion_de_actividades_a_desempenar" type="text" class="input w-full border mt-2" placeholder="Relacion de actividades a desempeñar" />
                            </label>
                        </div>
                    </div>
                    <div v-if="subcontrata.tipo == 'EMPRESA'">
                        <div class="mb-3">
                            <label>
                                <span>Nombre de la empresa</span>
                                <input v-model="subcontrata.nombre_de_la_empresa" type="text" class="input w-full border mt-2" placeholder="Nombre de la empresa" />
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>
                                <span>CIF</span>
                                <input v-model="subcontrata.cif" type="text" class="input w-full border mt-2" placeholder="CIF" />
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>
                                <span>Dirección</span>
                                <input v-model="subcontrata.dirección" type="text" class="input w-full border mt-2" placeholder="Dirección" />
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>
                                <span>Teléfono</span>
                                <input v-model="subcontrata.telefono" type="text" class="input w-full border mt-2" placeholder="Teléfono" />
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>
                                <span>Persona de contacto en materia de PRL</span>
                                <input v-model="subcontrata.persona_de_contacto_en_materia_de_prl" type="text" class="input w-full border mt-2" placeholder="Persona de contacto en materia de PRL" />
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>
                                <span>Mail</span>
                                <input v-model="subcontrata.mail" type="text" class="input w-full border mt-2" placeholder="Mail" />
                            </label>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end">
                    <button v-bind:class="{'opacity-50 cursor-not-allowed': !subcontrata.num, 'cursor-pointer': subcontrata.num}" @click="remove()" class="mt-4 mr-4 dropdown-toggle button text-white bg-theme-11 shadow-md flex items-center"> 
                        <XIcon class="mr-2"/>
                        Eliminar
                    </button>
                    <button v-bind:class="{'opacity-50 cursor-not-allowed': !canSave(), 'cursor-pointer': canSave()}" @click="canSave() && save()" class="mt-4 dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center"> 
                        <SaveIcon class="mr-2"/>
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            subcontrata: null,
            callback: null
        };
    },
    mounted() {
        window.bus.$on("modalCrearSubcontrata", (subcontrata) => {
            this.subcontrata = {
                num: subcontrata.num ? subcontrata.num : null,
                tipo: subcontrata.tipo ? subcontrata.tipo : '',
                nombre_y_apellidos: subcontrata.nombre_y_apellidos ? subcontrata.nombre_y_apellidos : '',
                dni: subcontrata.dni ? subcontrata.dni : '',
                relacion_de_actividades_a_desempenar: subcontrata.relacion_de_actividades_a_desempenar ? subcontrata.relacion_de_actividades_a_desempenar : '',
                nombre_de_la_empresa: subcontrata.nombre_de_la_empresa ? subcontrata.nombre_de_la_empresa : '',
                cif: subcontrata.cif ? subcontrata.cif : '',
                dirección: subcontrata.dirección ? subcontrata.dirección : '',
                telefono: subcontrata.telefono ? subcontrata.telefono : '',
                persona_de_contacto_en_materia_de_prl: subcontrata.persona_de_contacto_en_materia_de_prl ? subcontrata.persona_de_contacto_en_materia_de_prl : '',
                mail: subcontrata.mail ? subcontrata.mail : '',
            }
        });
    },
    methods: {
        canSave() {
            let errors = [];
            let datos_empresa = ['nombre_de_la_empresa', 'cif', 'dirección', 'telefono', 'persona_de_contacto_en_materia_de_prl', 'mail'];
            let datos_autonomo = ['nombre_y_apellidos', 'dni', 'relacion_de_actividades_a_desempenar'];
            Object.keys(this.subcontrata).forEach((key) => {
                let error = 0;
                // Si es el tipo empresa, no revisamos los datos autónomo, y al revés.
                if(this.subcontrata['tipo'] == 'EMPRESA' && datos_autonomo.indexOf(key) !== -1) {
                    // No se comprueba
                } else if(this.subcontrata['tipo'] == 'AUTONOMO' && datos_empresa.indexOf(key) !== -1) {
                    // No se comprueba
                } else {
                    error = (this.subcontrata[key]=='')?1:0
                }
                errors.push(error)
            });
            errors = errors.reduce((a,b) => a+b);
            if(errors) return false;
            return true;
        },
        remove() {
            if(confirm('¿Seguro? La subcontrata quedará eliminada.')) {
                this.subcontrata.desactivado = 1;
                this.save();
            }
        },
        async save() {
            let response = await CmsApi.hook('/hooks/save/', {
                'action': 'subcontrata',
                'data': JSON.stringify(this.subcontrata),
                'token': this.$cookie.get("token")
            });
            if(response.success) {
                window.bus.$emit("reloadDataFromServer", {});
                this.subcontrata = null;
            } else {
                console.log(response)
            }
        }
    }
};
</script>